import React from 'react';
import RRTable from "../../components/rr-table/RRTable";
import {PrintIconButton, XlsIconButton} from "../../components/IconButtons";

interface TruckStat {
    truckId: string;
    name: string;
    plate: string;
    totalPrice: number;
    totalFuel: number;
    totalDelta: number;
    totalKm: number;
}

interface DriverStat {
    driverId: string;
    name: string;
    totalPrice: number;
    totalFuel: number;
    totalDelta: number;
    totalKm: number;
}

interface Totals {
    totalPrice: number;
    totalFuel: number;
    totalDelta: number;
    avgPriceForKm: number;
    totalKm: number;
    // average consumption (fuel per km)
    avgConsumptionPerKm: number;
}

interface Props {
    statsByTruck: TruckStat[];
    statsByDriver: DriverStat[];
    totals: Totals;
    statsTableRef?: React.RefObject<HTMLTableElement>;
    onExportStats?: () => void;
    onPrint?: () => void;
}

const FuelInvoicesStats: React.FC<Props> = ({statsByTruck, statsByDriver, totals, statsTableRef, onExportStats, onPrint}) => {
    return (
        <div>
            <div className="mb-2">
                <PrintIconButton onClick={() => onPrint && onPrint()} />&nbsp;
                <XlsIconButton onClick={() => onExportStats && onExportStats()} />
            </div>

            <RRTable ref={statsTableRef}>
                <thead>
                <tr>
                    <th>Шофьор / Превозно средство</th>
                    <th className="text-end">Цена</th>
                    <th className="text-end">Кол.гориво</th>
                    <th className="text-end">Изм.км</th>
                    <th className="text-end">Разх./100 км</th>
                    <th className="text-end">Цена/км</th>
                    <th className="text-end">Общо км</th>
                </tr>
                </thead>
                <tbody>
                {/* totals row */}
                <tr className="table-secondary fw-bold">
                    <td></td>
                    <td className="text-end">{totals.totalPrice.toFixed(2)}</td>
                    <td className="text-end">{totals.totalFuel.toFixed(2)}</td>
                    <td className="text-end">{totals.totalDelta}</td>
                    <td className="text-end">{(totals.avgConsumptionPerKm * 100).toFixed(2)}</td>
                    <td className="text-end">{totals.avgPriceForKm.toFixed(2)}</td>
                    <td className="text-end">{totals.totalKm}</td>
                </tr>

                {/* driver rows */}
                {statsByDriver.map(d => (
                    <tr key={d.driverId || d.name}>
                        <td>{d.name}</td>
                        <td className="text-end">{d.totalPrice.toFixed(2)}</td>
                        <td className="text-end">{d.totalFuel.toFixed(2)}</td>
                        <td className="text-end">{d.totalDelta}</td>
                        <td className="text-end">{(d.totalDelta > 0 ? (d.totalFuel / d.totalDelta * 100).toFixed(2) : '0.00')}</td>
                        <td className="text-end">{(d.totalDelta > 0 ? (d.totalPrice / d.totalDelta).toFixed(2) : '0.00')}</td>
                        <td className="text-end">{d.totalKm}</td>
                    </tr>
                ))}

                {/* truck rows */}
                {statsByTruck.map(s => (
                    <tr key={s.truckId || s.name}>
                        <td>{s.name}{s.plate ? ` (${s.plate})` : ''}</td>
                        <td className="text-end">{s.totalPrice.toFixed(2)}</td>
                        <td className="text-end">{s.totalFuel.toFixed(2)}</td>
                        <td className="text-end">{s.totalDelta}</td>
                        <td className="text-end">{(s.totalDelta > 0 ? (s.totalFuel / s.totalDelta * 100).toFixed(2) : '0.00')}</td>
                        <td className="text-end">{(s.totalDelta > 0 ? (s.totalPrice / s.totalDelta).toFixed(2) : '0.00')}</td>
                        <td className="text-end">{s.totalKm}</td>
                    </tr>
                ))}
                </tbody>
            </RRTable>
        </div>
    );
};

export default FuelInvoicesStats;
